const projects = [
  {
    id: 1,
    title: "Employee Productivity Analysis",
    image: "/assets/images/employee-project.webp",
    icon: "fas fa-chart-line",
    date: "2024-2025 | Bangalore, India",
    description: [
      "Created a Web Dashboard where you can import datasets to analyze productivity of your employees",
      "Got A grade in college for this Project"
    ],
    techStack: ["Python", "Data Analysis", "Dashboard"],
    githubLink: "https://github.com/sDash151/Employee-Productivity"
  },
  {
    id: 2,
    title: "MERN Restaurant Reservation Website",
    image: "/assets/images/restaurant-project.jpeg",
    icon: "fas fa-utensils",
    date: "2024-2025 | Bangalore, India",
    description: [
      "Created a Restaurant Reservation Website Using MERN Stack",
      "Got approached by a restaurant owner for this Project"
    ],
    techStack: ["MongoDB", "Express.js", "React", "Node.js"],
    githubLink: "https://github.com/sDash151/MERN_Restaurant_Reservation_Website"
  },
  {
    id: 3,
    title: "Learning App For Deaf And Mute",
    image: "/assets/images/learning-project.jpg",
    icon: "fas fa-hands-helping",
    date: "2024-2025 | Bangalore, India",
    description: [
      "Developing a learning app for Deaf and Mute Using Machine Learning and various other Technological Stacks",
      "Got selected on the regional level for Smart India Hackathon 2024"
    ],
    techStack: ["Machine Learning", "React Native", "AI"],
    githubLink: "https://github.com/sDash151/VAANI-APP"
  },
  {
    id: 7,
    title: "EventPulse – Real-Time RSVP & Feedback Platform",
    image: "/assets/images/Event_Pulse.png",
    icon: "fas fa-bolt",
    date: "2025 | Bangalore, India",
    description: [
      "Built in a hackathon by MisogiAI initiative (Masai School)",
      "Hosts create/manage events, set RSVP deadlines, and track live attendance",
      "Attendees RSVP, check in, and give instant feedback (comments & emojis)",
      "Live feedback stream and real-time analytics for hosts",
      "Secure login, mobile-first UI, and smart notifications"
    ],
    techStack: ["React", "Node.js", "Express", "MongoDB", "WebSockets", "Chart.js"],
    githubLink: "https://github.com/sDash151/PulseEvent_Backend"
  },
  {
    id: 8,
    title: "GlobeTrekker – Ultimate Travel Companion",
    image: "/assets/images/GlobeTrekker.png",
    icon: "fas fa-globe",
    date: "2025 | Bangalore, India",
    description: [
      "AI-powered app for trip planning, budgeting, and packing",
      "Interactive 3D globe with cost overlays and travel stories feed",
      "AR packing simulator and climate-adaptive recommendations",
      "Real-time budget tracker, currency conversion, and safety alerts",
      "Clean, mobile-first UI with dark mode and smooth animations"
    ],
    techStack: ["React", "TensorFlow.js", "Three.js", "Framer Motion", "Node.js", "Express"],
    githubLink: ""
  },
  {
    id: 9,
    title: "Micro Frontend Music Library Portal",
    image: "/assets/images/MusicLibrary.png",
    icon: "fas fa-music",
    date: "2025 | Bangalore, India",
    description: [
      "Music library UI with filter, sort, and group by album, artist, title",
      "Micro frontend architecture: main app + dynamic music library module",
      "Role-based access: admin (add/delete), user (view/filter only)",
      "Mock JWT authentication, no backend required",
      "Deployed main app and micro frontend with live demo links"
    ],
    techStack: ["React", "Vite", "Module Federation", "JavaScript", "Tailwind CSS"],
    githubLink: "https://github.com/sDash151/Music-main-app"
  },
  {
    id: 4,
    title: "PUBG - A Gaming Website",
    image: "/assets/images/pubg-project.png",
    icon: "fas fa-gamepad",
    date: "2024-2025 | Bangalore, India",
    description: [
      "Developed a website in a coding competition where we had to create a specific website according to a topic under 1 hour using AI",
      "Won first prize for this project."
    ],
    techStack: ["HTML", "CSS", "JavaScript", "Responsive"],
    githubLink: "https://github.com/sDash151/PUBG-A-Gaming-Website-"
  },
  {
    id: 5,
    title: "Smart Plant Monitoring System",
    image: "/assets/images/plant-project.webp",
    icon: "fas fa-cogs",
    date: "2024-2025 | Bangalore, India",
    description: [
      "Developed a Smart plant monitoring system that uses sensors and microprocessor like ESP-8266 to read real time data about your plant and will send you the status of your plant using Email and SMS.",
      "Got A Grade in IoT Exhibition."
    ],
    techStack: ["IoT", "Embedded C", "C++", "Python", "Sensors", "Microprocessors"],
    githubLink: "https://github.com/sDash151/SMART-PLANT-MONITORING-SYSTEM"
  },
  {
    id: 6,
    title: "My City Website",
    image: "/assets/images/city-project.jpg",
    icon: "fas fa-landmark",
    date: "2024-2025 | Bangalore, India",
    description: [
      "Developed a website of my hometown, Balasore, that tells you how to explore the town and what cuisines to try and gives a brief description about the history of the town.",
      "Got A Grade in Web Technology Project Presentation."
    ],
    techStack: ["HTML", "CSS", "JavaScript", "Responsive"],
    githubLink: "https://github.com/sDash151/My-City-Website"
  }
];

export default projects;